import { render, staticRenderFns } from "./points_use_rules_setting.vue?vue&type=template&id=f36ad49e&scoped=true&"
import script from "./points_use_rules_setting.vue?vue&type=script&lang=ts&"
export * from "./points_use_rules_setting.vue?vue&type=script&lang=ts&"
import style0 from "./points_use_rules_setting.vue?vue&type=style&index=0&id=f36ad49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36ad49e",
  null
  
)

export default component.exports